/* eslint-disable react/no-danger */
import Head from 'next/head';
import { initAckoAnalytics } from '@acko-tech/building-blocks.ui.acko-analytics';
import Cookies from 'js-cookie';
import { getSegmentKey } from 'utils/segment/credentials';

export const initialiseAckoAnalytics = () => {
    const trackerId = Cookies.get('trackerid') || '';

    return (
        <Head>
            {!!trackerId ? (
                <script
                    async
                    defer
                    type="text/javascript"
                    dangerouslySetInnerHTML={{
                        __html: initAckoAnalytics(
                            trackerId,
                            getSegmentKey(window?.location?.hostname)
                        ),
                    }}
                ></script>
            ) : null}
        </Head>
    );
};
